<!--<c-footer>-->
  <div>
    <span> &copy; {{ currentYear }} EMC Ltd.</span>
    <span> Sagel v.1.7.1</span>
  </div>
  <div class="ms-auto">

  </div>
<!--</c-footer>-->
